<template lang="pug">
  div.auth.login
    div.modal.login
      div.modal.login-inner
        form.center(@submit.prevent="onSubmit")
          h1 Электронная модель территориальной схемы обращения с отходами на территории Краснодарского края
          div.input
            input(type="text" name="username" v-model="username" placeholder="Логин" required minlength=2)
          div.input
            input(type="password" name="password" v-model="password" placeholder="Пароль" required minlength=2)
          div
            button(type="submit" id="submit" v-bind:disabled="loading") {{loading ? 'Загрузка...' : 'Вход'}}
          transition(name="fade")
            div(v-if="error")
              span {{error}}
          div.actions
            router-link(
             :to="{path: 'request-reset-password'}"
            ) Забыли пароль?
          div.links
            router-link(
            :to="{name: 'geo.objects'}"
            ) Публичная карта объектов
            router-link(
            :to="{name: 'geo.treads'}"
            ) Публичная схема потоков
</template>

<script>
  import loginFormMixin from '../mixins/login-form'

  export default {
    name: 'login',
    mixins: [loginFormMixin]
  }
</script>
